import { AfterViewInit, Component, ElementRef, HostListener, NgZone, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { Casa, PuntoCasa, Visor360 } from './visor-360';

/**
 * PROTOTIPO /home-piloto: banner con foto 360° real y recorrido tipo Matterport.
 * La casa sale de una carpeta: assets/recorrido/<casa>/casa.json + fotos/*.jpg (ver LEEME.md ahí).
 */
const CARPETA_CASA = 'assets/recorrido/casa-ejemplo/';

@Component({
	selector: 'app-home-piloto',
	templateUrl: './home-piloto.component.html',
	styleUrls: ['./home-piloto.component.scss']
})
export class HomePilotoComponent implements OnInit, AfterViewInit, OnDestroy {
	@ViewChild('fondoBanner') fondoBanner!: ElementRef<HTMLDivElement>;
	@ViewChild('lienzoTour') lienzoTour?: ElementRef<HTMLDivElement>;

	urlCompra = environment.URL_MICROSITIO;
	carpeta = CARPETA_CASA;
	casa?: Casa;
	bannerListo = false;
	tourAbierto = false;
	tourListo = false;
	punto?: PuntoCasa;
	pista = true;

	private banner?: Visor360;
	private tour?: Visor360;

	constructor(private title: Title, private meta: Meta, private zone: NgZone) { }

	ngOnInit(): void {
		this.title.setTitle('Recorrido virtual | Sorteo Anáhuac (prototipo)');
		this.meta.updateTag({ name: 'robots', content: 'noindex, nofollow' });
	}

	async ngAfterViewInit(): Promise<void> {
		const r = await fetch(this.carpeta + 'casa.json');
		this.casa = await r.json();
		this.zone.runOutsideAngular(() => {
			this.banner = new Visor360(this.fondoBanner.nativeElement, {
				base: this.carpeta, casa: this.casa!, cine: true,
				alCargar: () => this.zone.run(() => (this.bannerListo = true)),
			});
			this.banner.iniciar();
		});
	}

	ngOnDestroy(): void {
		this.meta.removeTag("name='robots'");
		if (this.banner) this.banner.destruir();
		if (this.tour) this.tour.destruir();
		document.body.style.overflow = '';
	}

	get portada(): string {
		const p = this.casa && this.casa.puntos.find((x) => x.id === this.casa!.portada);
		return p ? this.carpeta + p.foto : '';
	}

	get puntosPlano(): PuntoCasa[] {
		return this.casa ? this.casa.puntos.filter((p) => p.plano) : [];
	}

	/** líneas del plano entre puntos conectados (calculadas una vez) */
	private _lineas?: number[][];
	get lineas(): number[][] {
		if (!this._lineas && this.casa) {
			const pos = new Map(this.puntosPlano.map((p) => [p.id, p.plano!] as [string, number[]]));
			const vistas = new Set<string>();
			this._lineas = [];
			for (const p of this.puntosPlano) for (const c of p.conexiones) {
				const k = [p.id, c.a].sort().join('|');
				const b = pos.get(c.a);
				if (b && !vistas.has(k)) { vistas.add(k); this._lineas.push([p.plano![0], p.plano![1], b[0], b[1]]); }
			}
		}
		return this._lineas || [];
	}

	abrirTour(id?: string): void {
		if (!this.casa) return;
		this.tourAbierto = true;
		this.tourListo = false;
		this.pista = true;
		document.body.style.overflow = 'hidden';
		setTimeout(() => {
			this.zone.runOutsideAngular(() => {
				this.tour = new Visor360(this.lienzoTour!.nativeElement, {
					base: this.carpeta, casa: this.casa!,
					alCargar: () => this.zone.run(() => (this.tourListo = true)),
					alCambiar: (p) => this.zone.run(() => (this.punto = p)),
				});
				this.tour.iniciar(id || this.casa!.puntos[0].id);
			});
			setTimeout(() => (this.pista = false), 6000);
		});
	}

	cerrarTour(): void {
		if (this.tour) this.tour.destruir();
		this.tour = undefined;
		this.tourAbierto = false;
		document.body.style.overflow = '';
	}

	ir(p: PuntoCasa): void {
		this.pista = false;
		if (this.tour) this.tour.irA(p.id);
	}

	@HostListener('document:keydown.escape')
	escape(): void {
		if (this.tourAbierto) this.cerrarTour();
	}
}
